<template>
  <div>
    <Mainl @mlogin="mlogin" @scrollTo="scrollTo"></Mainl>
    <div class="page_content">
      <div class="case_list_filter">
        <div class="case_list_search_wrap">
          <img class="search_icon" :src="require('@/assets/img/icon_search.png')" />
          <el-input  popper-class="search_popper_class" size="small" clearable @clear="initList(0)" class="search_input" v-model="form.name" placeholder="请输入关键词搜索案例名称"></el-input>
          <div class="case_list_search_btn" @click="initList(0)">搜索</div>
        </div>

        <!--
        <div class="case_list_select">
          <el-select style="width: 248px;margin-right: 24px;" size="small" v-model="form.money" placeholder="请选择该项目的金额区间">
            <el-option
                v-for="(key, val) in xy_case_money_dict"
                :key="val"
                :label="key"
                :value="val">
            </el-option>
          </el-select>
          <el-cascader
              size="small"
              v-model="industry_info"
              :options="industry_dic"
              @change="industryChange"
              placeholder="请选择该案例的所属行业"
              style="width: 248px;margin-right: 24px;"
          ></el-cascader>
          <el-cascader
              size="small"
              v-model="category_info"
              :options="category_dic"
              @change="categoryChange"
              placeholder="请选择所属创意类目"
              style="width: 352px;margin-right: 24px;"
          ></el-cascader>
          <div class="case_list_btn">
            <el-button style="height: 32px;padding: 9px 20px;" type="primary" @click="initList(0)">查询</el-button>
            <el-button style="height: 32px;padding: 9px 20px;margin-left: 16px;" @click="resetList">重置</el-button>
          </div>
        </div>
        -->
      </div>
      <div class="case_list_wrap">
        <div class="case_list_industry">
          <!--
          <div class="case_list_industry_label">
            所属行业
          </div>
          -->
          <el-select style="width: 248px" v-model="form.industry_top_id" @change="industrySelecrChange" placeholder="请选择案例所属行业" clearable>
            <el-option v-for="item in industry_dic" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="case_list_select_option">
          <span :class="form.category_key === '' ? 'case_list_select_active' : ''" @click="checkCategoryKey('')">全部</span>
          <span :class="form.category_key === item.Key ? 'case_list_select_active' : ''" :key="key" v-for="(item, key) in top_creative_categories_dict"  @click="checkCategoryKey(item.Key)" >{{item.Value}}</span>
        </div>
        <div class="case_list_select_children_option" v-show="second_creative_categories_dict.length > 0">
          <span :class="in_array(item.value, checkedSecondCategoryIdArr) ? 'case_list_select_children_option_active' : ''" :key="key" v-for="(item, key) in second_creative_categories_dict" @click="categoryChange(item.value)">{{item.label}}</span>
        </div>

        <div v-if="caseList.length > 0" class="case_card_list">
          <div v-for="(item, key) in caseList" class="case_card_list_item"  :key="key" @click="goDetail(item)">
            <!-- <img :src="item.cover_url" v-if="item.cover_url != ''" 1 />
            <img src="https://fakeimg.pl/250x100/" v-else alt=""> -->
            <el-image  :src="item.cover_url" lazy></el-image>
            <div class="case_card_list_item_content">
              <span>{{ item.name }}<img v-if="case_white_id.length > 0 && in_array(item.create_uid, case_white_id)" :src="require('@/assets/img/preferred_case_flag.png')" alt="" style="width: 17px;position: relative; top: 2px; left: 5px;"></span>
              <span :style="case_white_id.length > 0 && in_array(item.create_uid, case_white_id) ? 'font-weight: 600; color: black' : ''">{{ item.case_company }}</span>
            </div>
          </div>
        </div>
        <div v-else class="case_card_list_no_data">
          <img  :src="require('@/assets/img/demand/img_empty.png')"/>
          <p>案例库还在补充中…</p>
        </div>
        <div v-show="caseList.length > 0" class="case_list_page">
          <span>共{{caseCount}}个案例</span>
          <div class="pagination_wrap">
            <!-- hide-on-single-page -->
            <el-pagination
                background
                layout="prev, pager, next"
                :total="caseCount"
                :current-page="currentPage"
                :page-size="pageSize"
                @current-change="handlePageChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Mainl from '@/components/Mainl.vue'
// import axios from 'axios'
// import Cookies from 'js-cookie'
// eslint-disable-next-line
import * as commfun from '@/common/common.js'
import Cookies from 'js-cookie'
var pubPrefix = '/api'
export default {
  name: 'DemandCaseList',
  components: {
    Mainl
  },
  data: function () {
    return {
      form: {
        name: '',
        money: '',
        category_id: '',
        industry_id: '',
        industry_top_id: '',
        category_key: ''
      },
      industry_info: [], // 选中的行业数据
      category_info: [], // 选中的创意类目数据
      caseList: [],
      xy_case_money_dict: [], // 项目金额字典
      industry_dic: [], // 所属行业字典
      category_dic: [], // 创意类目字典
      top_creative_categories_dict: [], // 单一级创意类目字典
      second_creative_categories_dict: [],  // 二级创意类目字典
      caseCount: 0,
      currentPage: 1,
      pageSize: 18, // 每页数量
      case_white_id: [],
      checkedSecondCategoryIdArr: [],  // 选中的二级创意类目ID
    }
  },
  created () {
    // 获取字典数据
    this.getDict()
  },
  mounted () {
    this.initList(0)
  },
  methods: {
    // 获取字典
    getDict () {
      var selfthis = this
      var url = pubPrefix + '/api/case/dict'
      commfun.ajaxGet(selfthis, url, {}, function (selfthis, result) {
        selfthis.xy_case_money_dict = result.xy_case_money_dict
        selfthis.industry_dic = result.industry_dic
        selfthis.category_dic = result.category_dic
        selfthis.top_creative_categories_dict = result.top_creative_categories_dict
      }, function (selfthis, result) {
        selfthis.$message({
          showClose: true,
          message: '字典查询错误，请联系管理员！',
          type: 'warning',
          customClass: 'zZindex'
        })
      })
    },
    // 列表数据
    initList: function (list_type = 0) {
      var selfthis = this
      var url = pubPrefix + '/api/case/caseList'
      var postdata={
        category_key: this.form.category_key,
        name:this.form.name,
        money:this.form.money,
        category_id:this.form.category_id,
        industry_id:this.form.industry_id,
        industry_top_id:this.form.industry_top_id,
        pageSize:this.pageSize,
        currentPage:this.currentPage,
      }
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        if (list_type == 0 && selfthis.category_info.length > 0) {
          selfthis.form.category_key = selfthis.category_info[0]
        }
        if (data == null || data === undefined) {
          selfthis.caseList = []
          selfthis.caseCount = 0
        } else {
          selfthis.case_white_id = data.case_white_id
          selfthis.caseList = data.data
          selfthis.caseCount = data.count
        }
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 重置筛选条件
    resetList () {
      for(var i in this.form){
        this.form[i]=""
      }
      this.industry_info = []
      this.category_info = []
      this.initList(0)
    },
    // 行业选择
    industryChange(value){
      if (this.industry_info.length > 0) {
        // 现在加一级行业了
        this.form.industry_top_id = this.industry_info[0]
        this.form.industry_id = this.industry_info[1]
      } else {
        this.form.industry_top_id = ''
        this.form.industry_id = ''
      }
    },
    // 行业下拉选择  现在只能选一级行业
    industrySelecrChange (industry_top_id) {
      this.form.industry_top_id = industry_top_id
      this.initList(1)
    },
    // 创意类目筛选
    categoryChange (value) {
      if (value != '') {
        if (this.in_array(value, this.checkedSecondCategoryIdArr)) {
          this.checkedSecondCategoryIdArr = this.checkedSecondCategoryIdArr.filter(element => element !== value);
        } else {
          this.checkedSecondCategoryIdArr.push(value)
        }
      }
      if (this.checkedSecondCategoryIdArr.length > 0) {
        this.form.category_id = this.checkedSecondCategoryIdArr.join(',')
      } else {
        this.form.category_id = ''
      }
      this.initList(1)
      /*
      if (this.category_info.length > 0) {
        this.form.category_id = this.category_info[1]
      } else {
        this.form.category_id = ''
      }
      */
    },
    // 一级创意类目选择
    checkCategoryKey (val) {
      this.form.category_key = val
      this.checkedSecondCategoryIdArr = []
      this.form.category_id = ''
      // 设置二级类目
      this.second_creative_categories_dict = []
      if (val != '') {
        for (var i = 0; i < this.category_dic.length; i ++) {
          if (val == this.category_dic[i].value) {
            this.second_creative_categories_dict = this.category_dic[i].children
          }
        }
      }
      this.initList(1)
    },
    // 切换页码
    handlePageChange(currentPage) {
      // 处理页码变化回调，更新 currentPage 并重新获取数据
      this.currentPage = currentPage;
      this.initList(0);
    },
    // 案例详情
    goDetail (item) {
      window.open('/casedetail?id=' + item.case_id + '&jump_from=1')
    },
    mlogin: function (type) {
      if (type === 'example') {
        this.visible = true
      } else {
        this.visible2 = true
      }
    },
    scrollTo: function (type) { // 滚动到位置 锚点
      document.querySelector('#' + type).scrollIntoView(true)
    },
    // 判断指定值是否在指定数组中
    in_array (search, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] === search) {
          return true;
        }
      }
      return false;
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DemandCaseList.vue